import { Pipe, PipeTransform, computed, signal } from '@angular/core';
import { maskitoTransform } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { PrincipalService } from '@ms/core/auth/principal.service';
import { CurrencyFormatType } from '@ms/core/components/login/state/session.store';
import { isEmpty } from '@ms/core/util/date-util';
import { CurrencySymbol } from 'app/main/shared/enum/currencyType.enum';

@Pipe({
    name: 'money',
    pure: false,
})
export class MoneyPipe implements PipeTransform {
    _value: string;
    lastValue: number;
    lastCurrency: string;
    msk: CurrencyFormatType;
    option = computed(() => {
        return maskitoNumberOptionsGenerator({
            thousandSeparator: this.thousandsSeparator(),
            decimalSeparator: this.decimalSeparator(),
            precision: 2,
        });
    });
    decimalSeparator = signal<string>('.');
    thousandsSeparator = signal<string>(',');
    constructor(private _principle: PrincipalService) {
        this.msk = { ...this._principle.profile.format.currency };
        this.decimalSeparator.set(this.msk.decimalSeparator);
        this.thousandsSeparator.set(this.msk.thousandsSeparator);
    }

    /**
     * @param value The number to be formatted.
     * @param digitsInfo Decimal representation options, specified by a string
     * in the following format:<br>
     * <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>.
     *   - `minIntegerDigits`: The minimum number of integer digits before the decimal point.
     * Default is `1`.
     *   - `minFractionDigits`: The minimum number of digits after the decimal point.
     * Default is `0`.
     *   - `maxFractionDigits`: The maximum number of digits after the decimal point.
     * Default is `3`.
     * @param locale A locale code for the locale format rules to use.
     * When not supplied, uses the value of `LOCALE_ID`, which is `en-US` by default.
     * See [Setting your app locale](guide/i18n#setting-up-the-locale-of-your-app).
     */
    transform(value: number, currency?: string, useBracketsForNegative = true): string | null {
        if (value == this.lastValue && currency == this.lastCurrency) {
            return this._value;
        }
        this.lastValue = value;
        this.lastCurrency = currency;

        if (isEmpty(value) || value == 0) {
            this._value =
                maskitoTransform(`${value}`, this.option()) + (currency ? ` ${CurrencySymbol[currency]}` : '');
            console.log('FORMAT', this._value);
            return this._value;
        }
        try {
            const rawValue = `${useBracketsForNegative ? Math.abs(value) : value}`.replaceAll(
                '.',
                this.decimalSeparator()
            );
            const result = (this._value =
                maskitoTransform(rawValue, this.option()) + (currency ? ` ${CurrencySymbol[currency]}` : ''));
            console.log('FORMAT', result);
            if (useBracketsForNegative && value < 0) {
                return (this._value = `(${result})`);
            } else {
                return (this._value = result);
            }
        } catch (error) {
            return (this._value = '');
        }
    }
}
